<div class="corepages">

<mat-card class="filter">
  <button mat-button [matMenuTriggerFor]="menu"><mat-icon>group_work</mat-icon> Grouping<mat-icon>keyboard_arrow_down</mat-icon></button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="CCCListing()"><mat-icon>list</mat-icon> List View</button>
    <button mat-menu-item (click)="CCCKanban()"><mat-icon>view_kanban</mat-icon> Kanban View</button>    
    <button mat-menu-item (click)="CCCGridView()"><mat-icon>group_work</mat-icon> Grouping view</button>
  </mat-menu>

  <button mat-flat-button  class="user-button">
    {{ orgModuleName}} ({{totalCount}})
  </button>

  <div class="search">
    <mat-form-field appearance="">
      <mat-label>Search items in {{orgModuleName}} </mat-label>
      <input matInput type="text" [(ngModel)]="value"
        (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)">
      <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>close</mat-icon>
      </button>
      <button color="basic" *ngIf="!value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>
  </div>

  <button class="viewBtn" mat-icon-button  matTooltipClass="tooltip" matTooltip="Customize Column"
    (click)="customizeColumn(customize)">
    <mat-icon>view_column</mat-icon>
</button>

  </mat-card>
  <div class="zui-wrapper">
      <div class="zui-scroller">
        <mat-card class="groupListingHolder">
          <mat-table [dataSource]="dataSource" class="mat-elevation-z8" [style.width]="colCount*200+'px'">
          
            <ng-container *ngFor="let column of columns; let i = index" matColumnDef="{{ column }}">
              <mat-header-cell *matHeaderCellDef>{{ column }}
          
                <button class="grid-view-header-menu"
                  mat-icon-button [matMenuTriggerFor]="menu">
                  <mat-icon>menu</mat-icon>
                </button>
          
                <mat-menu #menu>
                  <button mat-menu-item (click)="groupBy($event, column);">Group By This Field</button>
                  <button mat-menu-item (click)="unGroupBy($event, column);">Ungroup</button>
                </mat-menu>
          
              </mat-header-cell>
              <mat-cell *matCellDef="let row" (click)="showListingDetail(row,column)">  
                <ng-container *ngIf="i == 0">
                  <div class="name" (click)="ViewProfile(row,column)">
                    {{ row[column] }}
                  </div>
                </ng-container>
                <ng-container *ngIf="i != 0">
                  
                    <ng-container *ngIf="isPhone(row, column)">
                      <app-email-phone [onlyPhone]="row[column]"></app-email-phone> 
                    </ng-container>
      
                    <div *ngIf="isEmail(row, column)">
                      <app-email-phone [onlyEmail]="row[column]"></app-email-phone> 
                    </div>
      
                    <div *ngIf="!isPhone(row, column) && !isEmail(row, column) "
                      [matTooltip]="row[column]" matTooltipClass="tooltip" matTooltipPosition="above"
                      [matTooltipDisabled]="!isPrimaryDiagnosis(column) || !row[column]">
                      {{row[column]}}
                    </div>
                    <!-- {{ row[column] }} -->
                
                </ng-container>
               
                <ng-container *ngIf="i == 0">                 
                    <div class="checkOrgname">
                    <button mat-icon-button color="primary" class="openNew"  matTooltip="Open in new window" (click)="OpenProfile(row)">
                      <mat-icon>open_in_new</mat-icon> </button>
                      </div>             
                </ng-container>
              </mat-cell>
            </ng-container>
          
              <mat-header-row mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        
              <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
          
              <!-- Group header -->
              <ng-container matColumnDef="groupHeader">
                  <mat-cell colspan="999" *matCellDef="let group">
                <mat-icon *ngIf="group.expanded">expand_less</mat-icon>
                <mat-icon *ngIf="!group.expanded">expand_more</mat-icon>
                      <strong>{{groupByColumns[group.level-1]}} = {{group[groupByColumns[group.level-1]]}} ({{group.totalCounts}})</strong>
                </mat-cell>
            </ng-container>
          
            <mat-row *matRowDef="let row; columns: ['groupHeader']; when: isGroup" (click)="groupHeaderClick(row)"> </mat-row>
          
          </mat-table>
        </mat-card>
        
      </div>
  </div>


  
    <app-loader></app-loader>
  
    <div class="progress-loader" *ngIf="spinner">
  
      <div class="lds-ripple">
        <div></div>
        <div></div>
      </div>
    </div>
</div>


<ng-template #customize>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>view_column</mat-icon>
    </span>
    Select the columns you want to display in this list
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>


  <mat-dialog-content class="mat-typography">

    <div class="allheaders">
      <div class="fixrow sep">
        <span>Column Headers</span>
        <span> Active Columns</span>
      </div>

      <ng-container *ngFor="let item of FieldColumnToogle;let i = index">
        <div class="sep" *ngIf="i==0">
          <span>{{item.fieldName}}</span>
          <span>
            <mat-slide-toggle checked disabled color="primary"></mat-slide-toggle>
          </span>
        </div>
        
        <div class="sep" *ngIf="i!=0">
          <span>{{item.fieldName}}</span>
          <span>
            <mat-slide-toggle *ngIf="item.fieldName!='Status'" [checked]="item.isDisplay" color="primary" (change)="changedToggle(item,$event)">
            </mat-slide-toggle>

            <mat-slide-toggle *ngIf="item.fieldName=='Status'" checked disabled color="primary"></mat-slide-toggle>

          </span>
        </div>
      </ng-container>
    </div>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="SubmitColumnsButton==true" (click)="onSubmitColumns()">Save</button>
  </mat-dialog-actions>
</ng-template>


<app-details *ngIf="showDetail" [ngClass]="{ open: showDetail }" [transactionID]='TransactionId' [modulenames]='mainModuleName' 
(closeDetail)="getCloseDetails($event)" (SendtoSaved3C)=Saved3C($event)>
</app-details>
